import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { Card, ListGroup } from "react-bootstrap"

const deroulementSeance = ({ data }) => {
  return (
    <Layout>
      <SEO title="Déroulement d'une séance" />
      <div className="container py-5">
        <div className="row">
          <div className="col-md-12 mb-5">
            <h2>Déroulement d'une séance</h2>
          </div>
          <div className="col-md-4 mb-3">
            <Img fluid={data.img1.childImageSharp.fluid} />
          </div>
          <div className="col-md-8">
            <p>
              <strong>
                Chaque séance individuelle ou collective comporte&nbsp;:
              </strong>
              <br />
              <ListGroup variant="flush">
                <ListGroup.Item style={{ background: "none" }}>
                  <span role="img" aria-label="Backhand Index Pointing Right">
                    👉
                  </span>{" "}
                  Un temps d’accueil et d’échange avant chaque pratique, afin de
                  recueillir vos attentes, vos besoins et votre vécu depuis la
                  séance précédente
                </ListGroup.Item>
                <ListGroup.Item style={{ background: "none" }}>
                  <span role="img" aria-label="Backhand Index Pointing Right">
                    👉
                  </span>{" "}
                  Une pratique, en posture assise ou debout, les yeux fermés,
                  selon vos besoins du moment, que je guide pour vous, les yeux
                  fermés
                </ListGroup.Item>
                <ListGroup.Item style={{ background: "none" }}>
                  <span role="img" aria-label="Backhand Index Pointing Right">
                    👉
                  </span>{" "}
                  Un temps d’échange après chaque guidance permettant de
                  recueillir vos impressions, votre vécu, vos ressentis. Dans le
                  cas d’une séance collective, chacun est libre de s’exprimer ou
                  non. Je vous propose également des exercices à pratiquer chez
                  vous afin d’intégrer la sophrologie dans votre quotidien.
                </ListGroup.Item>
              </ListGroup>
              <br />
              <Card border="secondary" style={{ width: "100%" }}>
                <Card.Header>À savoir</Card.Header>
                <Card.Body>
                  <Card.Text>
                    La première séance peut durer jusqu’à une heure et demie,
                    car elle nécessite un temps d’accueil et d’échange plus long
                    pour faire le point sur votre situation, définir un objectif
                    et un programme d’accompagnement personnalisé de plusieurs
                    séances.
                  </Card.Text>
                </Card.Body>
              </Card>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    img1: file(relativePath: { eq: "deroulement-seance.jpg" }) {
      relativePath
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`

export default deroulementSeance
